export const REPORT_ID = 'slide-23';
export const SLIDE_NUMBER = 23;